import { Select, styled } from "@mui/material";
import { COLORS } from "assets";

const StyledSelect = styled(Select)(({ theme }) => {
  const isLight = theme.palette.mode === "light";
  return {
    backgroundColor: isLight ? COLORS.surface.card : theme.palette.text.primary,
    borderRadius: isLight ? COLORS.radius.pill : 8,
    color: isLight ? COLORS.surface.primaryText : theme.palette.text.secondary,
    border: isLight ? `1px solid ${COLORS.surface.border}` : 0,
    height: isLight ? "40px !important" : 55,
    minHeight: isLight ? "40px !important" : undefined,
    boxSizing: isLight ? "border-box" : undefined,
    padding: isLight ? 0 : 2,
    "& .MuiSelect-select": {
      // MUI Select defaults to variant="outlined", which applies 16.5px 14px
      // padding to the select value. Reset top/bottom to 0 so the text stays
      // vertically centered inside the 40px pill (matches FilterBar styling).
      padding: isLight ? "0 32px 0 16px !important" : undefined,
      height: isLight ? "40px !important" : undefined,
      lineHeight: isLight ? "40px !important" : undefined,
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      boxSizing: "border-box"
    },
    "& .MuiSelect-icon": {
      right: isLight ? 12 : undefined,
      top: isLight ? "50%" : undefined,
      transform: isLight ? "translateY(-50%)" : undefined,
      color: isLight ? COLORS.surface.secondaryText : theme.palette.text.secondary,
      pointerEvents: "none"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: isLight ? "none" : undefined
    }
  };
});
export default StyledSelect;
